import { baseApi } from "../baseApi";

export const warehousemaster = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDoctypeCount: builder.query({
      query: (doctype) => ({
        url: `/api/method/frappe.client.get_count`,
        params: { doctype },
      }),
    }),
    getwarehouseCount: builder.query({
      query: (doctype) => ({
        url: `/api/method/frappe.desk.reportview.get_count`,
        params: { doctype },
      }),
    }),

    getPaginatedDoctypeData: builder.query({
      query: ({ doctype, fields = ["name", "warehouse_type", "company", "creation"], start = 0, page_length = 20, filters = {} }) => {
        const params = {
          fields: JSON.stringify(fields),
          limit_start: start,
          limit_page_length: page_length,
        };

        if (Object.keys(filters).length > 0) {
          params.filters = JSON.stringify(filters);
        }

        return {
          url: `/api/resource/${doctype}`,
          params,
        };
      },
      transformResponse: (response) => ({
        full_data: response.data || [],
        total_no_of_records: response.total_length || 0
      }),
    }),
    getWarehouseOnlyParentData: builder.mutation({
      query: ({ doctype, limit_start = 0, limit_page_length = 20, filters = {},company }) => {
        const bodyfields = {
          company,
          limit_start,
          limit_page_length,
          filters
        };

        return {
          url: `/api${doctype}`,
          method:'POST',
          body:bodyfields
        };
      },
      transformResponse: (response) => ({
        full_data: response.message.data || [],
        total_no_of_records: response.message.total || 0
      }),
    }),
getParentWarehouses: builder.query({
  query: (companyName) => ({
    url: `/api/resource/Warehouse`,
    params: {
      filters: JSON.stringify([
        ["is_group", "=", 1],
        ["company", "=", companyName], // pass company dynamically
      ]),
    },
  }),
  transformResponse: (response) => response.data || [],
}),

    getCompanyList: builder.query({
      query: () => ({
        url: `/api/resource/Company`,
      }),
      transformResponse: (response) => response.data || [],
    }),
    getStockAccountsByCompany: builder.query({
      query: (companyName) => ({
        url: `/api/resource/Account`,
        params: {
          filters: JSON.stringify([
            ["is_group", "=", 0],
            ["account_type", "=", "Stock"],
            ["company", "=", companyName],
          ]),
        },
      }),
      transformResponse: (response) => response.data || [],
    }),
    createWarehouse: builder.mutation({
      query: (newWarehouseData) => ({
        url: `/api/resource/Warehouse`,
        method: 'POST',
        body: newWarehouseData,
      }),
      transformResponse: (response) => response.data || {},
    }),
    getWarehouseByName: builder.query({
      query: (warehouseName) => ({
        url: `/api/resource/Warehouse/${encodeURIComponent(warehouseName)}`,
      }),
      transformResponse: (response) => response.data || {},
    }),

    postWarehouseQuery: builder.mutation({
      query: ({ warehouseName, payload }) => ({
        url: `/api/resource/Warehouse/${warehouseName}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (response) => response.data || [],
    }),

    postWarehouseSearch: builder.mutation({
      query: ({start=0,search_input=""}) => ({
        url: '/api/resource/Warehouse',
        method: "GET",
        params: {
          start: start,
          filters: JSON.stringify([["name", "like", `%${search_input}%`]]),
          limit_page_length:1000
        }
      })
    }),
  }),
});

export const { useGetwarehouseCountQuery,
  useGetDoctypeCountQuery,
  useGetPaginatedDoctypeDataQuery,
  useGetParentWarehousesQuery,
  useLazyGetParentWarehousesQuery,
  useGetCompanyListQuery,
  useGetStockAccountsByCompanyQuery,
  useLazyGetStockAccountsByCompanyQuery,
  useCreateWarehouseMutation,
  useGetWarehouseByNameQuery,
  useLazyGetWarehouseByNameQuery,
  usePostWarehouseQueryMutation,
  usePostWarehouseSearchMutation,
  useGetWarehouseOnlyParentDataMutation

} = warehousemaster;